import { extend } from 'flarum/common/extend';
import { fetchLoginOptions, performAuthentication, submitLogin, isAutofillSupported, PasskeyClientError } from '../lib/webauthn';

/**
 * Wires up Conditional UI ("autofill") for passkey sign-in.
 *
 * Browsers expose saved passkeys as autofill suggestions on any input whose
 * `autocomplete` attribute contains the `webauthn` token, but only while a
 * `navigator.credentials.get({ mediation: 'conditional' })` call is in flight.
 *
 * Patches `LogInModal.prototype.oncreate` so the wiring happens at the exact
 * lifecycle point the input lands in the DOM. Failure modes (no platform
 * support, no registered credential) are silent: the password form stays
 * functional and the user never sees an error from this code path.
 */
export default function setupConditionalUi() {
  extend('flarum/forum/components/LogInModal', 'oncreate', function (_returnValue) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const vnode = args[0];
    const input = vnode.dom.querySelector('input[name="identification"]');
    if (!input) return;
    attach(input).catch(() => {});
  });
}
async function attach(input) {
  var _input$getAttribute;
  if (!(await isAutofillSupported())) return;

  // Preserve any existing autocomplete tokens (Flarum sets `username` on this
  // field) and append `webauthn` so the picker has somewhere to anchor.
  const existing = ((_input$getAttribute = input.getAttribute('autocomplete')) != null ? _input$getAttribute : '').split(/\s+/).filter(Boolean);
  if (!existing.includes('webauthn')) existing.push('webauthn');
  input.setAttribute('autocomplete', existing.join(' '));
  const options = await fetchLoginOptions();
  try {
    const credential = await performAuthentication(options, true);
    await submitLogin(credential, true);
    window.location.reload();
  } catch (err) {
    if (err instanceof PasskeyClientError && err.kind === 'cancelled') return;
    // Any other failure stays silent.
  }
}
flarum.reg.add('datlechin-passkey', 'forum/extenders/conditionalUiBootstrap', setupConditionalUi);